import { SITE } from "@/lib/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink-900">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 pt-16 md:pt-20 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pb-16 border-b border-line">
          <div className="col-span-2 md:col-span-1">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-acid">{SITE.brand}</p>
            <p className="mt-3 text-white/55 text-sm max-w-xs leading-relaxed">{SITE.tagline}</p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">Contact</p>
            <ul className="space-y-2 text-sm text-white/70">
              <li>{SITE.phone}</li>
              <li>{SITE.phone2}</li>
              <li className="break-all">{SITE.email}</li>
              <li className="pt-2 text-white/50">{SITE.address}</li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">Service area</p>
            <ul className="space-y-2 text-sm text-white/70">
              {SITE.serviceAreas.map((a) => (
                <li key={a}>{a}</li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">Navigate</p>
            <ul className="space-y-2 text-sm">
              {["Services", "Approach", "Proof", "Contact"].map((l) => (
                <li key={l}>
                  <a
                    href={`#${l === "Contact" ? "quote" : l.toLowerCase()}`}
                    className="text-white/70 hover:text-acid transition-colors"
                    data-testid={`footer-link-${l.toLowerCase()}`}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-10 select-none">
          <h2 className="font-display font-black tracking-tighter leading-none text-[22vw] md:text-[16vw] text-white">
            {SITE.brand}<span className="text-acid">.</span>
          </h2>
        </div>

        <div className="mt-8 flex flex-col md:flex-row gap-3 md:items-center md:justify-between font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
          <span>© {new Date().getFullYear()} {SITE.brandFull} · ABN {SITE.abn}</span>
          <div className="flex items-center gap-5">
            <span>Insured · Est. {SITE.established}</span>
            <a href="/login" data-testid="footer-admin-link" className="text-white/30 hover:text-acid transition-colors">Admin</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
